<template>
  <Card style="min-height: 333px">
    <template v-slot:title>
      <div class="p-grid p-jc-between">
        <div class="p-col">Faturas</div>
        <div class="p-col" style="text-align: right">
          <Button
            label="Adicionar Fatura"
            class="p-button-outlined"
            @click="invoiceModalVisible = true"
          />
        </div>
      </div>
    </template>
    <template v-slot:content>
      <DataTable dataKey="id" :value="results" responsiveLayout="stack">
        <Column header="Valor" field="billValue" :sortable="true">
          <template #body="{ data }">
            {{ data.billValue ? $toCurrency(data.billValue) : '-' }}
          </template>
        </Column>

        <Column header="Data de Vencimento" field="dueDate" :sortable="true">
          <template #body="{ data }">
            {{ data.dueDate ? $dayjs(data.dueDate).format('DD/MM/YYYY') : '-' }}
          </template>
        </Column>

        <Column header="Data do Pagamento" field="paidDate" :sortable="true">
          <template #body="{ data }">
            {{
              data.paidDate ? $dayjs(data.paidDate).format('DD/MM/YYYY') : '-'
            }}
          </template>
        </Column>

        <Column header="Link de pagamento" field="observation">
          <template #body="{ data }">
            <span v-if="data.paymentLink">
              <a
                :href="formatPaymentLink(data.paymentLink)"
                target="_blank"
                rel="noopener noreferrer"
              >
                Link
              </a>
            </span>
            <span v-else> - </span>
          </template>
        </Column>

        <Column header="Observações" field="observation">
          <template #body="{ data }">
            {{ data.observation || '-' }}
          </template>
        </Column>

        <Column header="Ações">
          <template #body="{ data }">
            <Button
              type="button"
              icon="pi pi-pencil"
              class="p-button-text p-button-secondary p-mr-1"
              @click="onEdit(data)"
            ></Button>
            <Button
              type="button"
              icon="pi pi-trash"
              class="p-button-text p-button-secondary"
              @click="onDeleteConfirm(data.id || data._id)"
            ></Button>
          </template>
        </Column>
      </DataTable>

      <Paginator
        v-if="accountId"
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="({ page }) => changeListPage({ page: page + 1 })"
      ></Paginator>
    </template>
  </Card>

  <InvoiceDialog
    ref="invoiceDialog"
    v-model:visible="invoiceModalVisible"
    @save="save($event)"
  ></InvoiceDialog>

  <AppModalDelete
    type="Fatura"
    :visible="deleteConfirm.visible"
    :item="deleteConfirm.item"
    @confirm="onDelete()"
    @cancel="hideDeleteConfirm()"
  ></AppModalDelete>
</template>

<script>
import useApiList from '../../../lib/useApiList';
import useDeleteConfirm from '../../../lib/useDeleteConfirm';
import { InvoiceApi } from '../../../services/api/admin';
import InvoiceDialog from './InvoiceDialog';

export default {
  name: 'InvoiceCard',
  components: {
    InvoiceDialog,
  },
  props: {
    accountId: Number,
    invoices: Array,
  },
  setup(props) {
    return {
      ...useApiList(InvoiceApi, { pageSize: 10, accountId: props.accountId }),
      ...useDeleteConfirm(),
    };
  },
  data() {
    return {
      invoiceModalVisible: false,
    };
  },
  async created() {
    if (this.accountId) {
      await this.fetchList();
    }
  },
  methods: {
    formatPaymentLink(link) {
      return link.startsWith('http') ? link : `https://${link}`;
    },
    onDeleteConfirm(id) {
      if (!this.accountId) {
        this.results = this.results.filter((result) => result._id !== id);
        this.$emit('update:invoices', this.results);
        return;
      }

      const item = this.results.find((result) => result.id === id);
      this.showDeleteConfirm(this.results, id, 'dueDate');
      this.deleteConfirm.item = this.$dayjs(item.dueDate).format('DD/MM/YYYY');
    },
    onEdit(data) {
      this.$refs.invoiceDialog.setData(data);
      this.invoiceModalVisible = true;
    },
    onDelete() {
      this.deleteListItem(this.deleteConfirm.id);
      this.hideDeleteConfirm();
    },
    async save({ data }) {
      if (!this.accountId) {
        if (!data._id) {
          data._id = new Date().getTime();
          this.results = [...this.results, data];
        } else {
          this.results = this.results.map((result) => {
            return result._id === data._id ? { ...result, ...data } : result;
          });
        }
        this.$emit('update:invoices', this.results);
        return;
      }

      const body = { ...data, accountId: this.accountId };
      if (!data.id) {
        await InvoiceApi.create(body);
      } else {
        await InvoiceApi.update(data.id, body);
      }
      await this.fetchList();
    },
  },
};
</script>

<style>
</style>
